import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getFromLocalStorage } from '../utils/localStorage';

// Props:
// - redirectToLogin: when true, unauthenticated users go to /login
//   with state { from: location } so LoginPage navigates back after auth.
//   When false (default), redirect to the Home features section (existing flow).
const ProtectedRoute = ({ children, redirectToLogin = false }) => {
  const [isChecking, setIsChecking] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = getFromLocalStorage('token');
    const loggedIn = (token && token.trim() !== '');
    setIsLoggedIn(loggedIn);

    if (!loggedIn) {
      if (redirectToLogin) {
        // Send user to login and preserve intended path for post-auth redirect
        const intended = `${location.pathname || ''}${location.search || ''}${location.hash || ''}`;
        try {
          // Store in sessionStorage as fallback (handles page reloads during auth)
          sessionStorage.setItem('postLoginRedirect', intended);
        } catch {}
        const nextUrl = `/login?next=${encodeURIComponent(intended)}`;
        navigate(nextUrl, { replace: true, state: { from: location } });
      } else {
        // Existing flow: send guests to Home features section
        navigate({ pathname: '/', hash: '#features' }, { replace: true });
      }
    }

    setIsChecking(false);
  }, [navigate, location, redirectToLogin]);

  if (isChecking) return null; // Avoid flashing content during check
  if (!isLoggedIn) return null; // Redirected

  return children;
};

export default ProtectedRoute;
